import React from 'react';

const Home = () => (
  <div>
    <h1>Home</h1>
  </div>
);

export default Home;
